(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[40],{

/***/ "1qr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAmountExpirationVouchersValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatVoucherValue; });
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wz9x");



var getAmountExpirationVouchersValues = function getAmountExpirationVouchersValues(vouchers, appContext) {
  var _sortedVouchers$;

  var sortedVouchers = lodash_sortBy__WEBPACK_IMPORTED_MODULE_0___default()(vouchers, function (_ref) {
    var validityEndDate = _ref.validityEndDate;
    return validityEndDate;
  }); //return no amount if more than one


  var ftcAmount = sortedVouchers.length > 1 ? '' : formatVoucherValue(sortedVouchers === null || sortedVouchers === void 0 ? void 0 : sortedVouchers[0], appContext.locale);
  var ftcExpirationDate = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_1__[/* formatApiDate */ "g"])(sortedVouchers === null || sortedVouchers === void 0 ? void 0 : (_sortedVouchers$ = sortedVouchers[0]) === null || _sortedVouchers$ === void 0 ? void 0 : _sortedVouchers$.validityEndDate, 'DD/MM/YYYY');
  return {
    ftcAmount: ftcAmount,
    ftcExpirationDate: ftcExpirationDate
  };
};
var formatVoucherValue = function formatVoucherValue(voucher, locale) {
  if (voucher.unit === 'PERCENTAGE' || voucher.unit === 'PERCENT') {
    return "".concat(voucher.value, "%");
  } else {
    return Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(voucher.value, locale, voucher.currency);
  }
};

/***/ }),

/***/ "KE+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBookmarksQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapBookmarkEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return mapSearchEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addBookmarkMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteBookmarkMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteCustomerProposalMutation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("HbGN");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);













function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var getBookmarksQuery = function getBookmarksQuery(appContext) {
  return "\n      id\n      productId\n      resortDepartureDate\n      resortArrivalDate\n      attendeesCount\n      adultsCount\n      childrenCount\n      birthdates\n      departureOptionId\n      product {\n        accommodations {\n          category\n          categoryId\n          comfortId\n          comfortType\n          id\n          roomType\n        }\n        badgeIcon\n        color\n        comfortLabel\n        destination {\n          country\n        }\n        hasECSpace\n        id\n        image\n        images\n        isExplicitEC\n        name\n        type\n        href\n      }\n      price {\n        amount\n        currency\n        formattedValue(precision:".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(appContext.locale), ")\n      }\n  ");
};

var mapBookmarkEntity = function mapBookmarkEntity(_ref) {
  var adultsCount = _ref.adultsCount,
      birthdates = _ref.birthdates,
      resortArrivalDate = _ref.resortArrivalDate,
      resortDepartureDate = _ref.resortDepartureDate,
      departureOptionId = _ref.departureOptionId,
      price = _ref.price,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_ref, ["adultsCount", "birthdates", "resortArrivalDate", "resortDepartureDate", "departureOptionId", "price"]);

  return _objectSpread(_objectSpread(_objectSpread({
    adultsNumber: adultsCount
  }, birthdates && {
    kids: birthdates.map(function (b) {
      return {
        birthdate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(b)
      };
    })
  }), {}, {
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(resortDepartureDate),
    arrivalDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(resortArrivalDate),
    departureCity: departureOptionId
  }, price && {
    priceOfStay: {
      bestPrice: {
        value: price.amount,
        formattedValue: price.formattedValue
      }
    }
  }), {}, {
    duration: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* momentFromApiDate */ "j"])(resortArrivalDate).diff(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* momentFromApiDate */ "j"])(resortDepartureDate), 'days'),
    origin: 'BOOKMARK'
  }, rest);
};

var mapSearchEntity = function mapSearchEntity(_ref2) {
  var adults = _ref2.adults,
      birthdates = _ref2.birthdates,
      returnDate = _ref2.returnDate,
      departureDate = _ref2.departureDate,
      departureCity = _ref2.departureCity,
      isBookable = _ref2.isBookable,
      price = _ref2.price,
      reference = _ref2.reference,
      resort = _ref2.resort,
      type = _ref2.type,
      upsells = _ref2.upsells;
  return _objectSpread(_objectSpread({
    adultsNumber: adults,
    id: reference,
    kids: (birthdates || []).map(function (b) {
      return {
        birthdate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(b)
      };
    }),
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(departureDate),
    arrivalDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* apiDateToTimestamp */ "e"])(returnDate),
    departureCity: departureCity
  }, price && {
    priceOfStay: {
      bestPrice: {
        value: price.value,
        formattedValue: price.formattedValue
      }
    }
  }), {}, {
    isBookable: isBookable,
    origin: 'SEARCH',
    product: resort,
    duration: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* momentFromApiDate */ "j"])(returnDate).diff(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* momentFromApiDate */ "j"])(departureDate), 'days'),
    reference: reference,
    type: type,
    upsells: upsells
  });
};

var favoriteQueryParams = function favoriteQueryParams(favoriteProduct) {
  var birthdates = favoriteProduct.kids.length ? "[\"".concat(favoriteProduct.kids.map(function (kid) {
    return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* timestampToApiDate */ "n"])(kid.birthdate);
  }).join('","'), "\"]") : '[]';
  return "\n  productId: \"".concat(favoriteProduct.product.id, "\",\n  resortArrivalDate: \"").concat(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* momentToApiDate */ "m"])(moment__WEBPACK_IMPORTED_MODULE_14___default()(favoriteProduct.departureDate).add(favoriteProduct.duration, 'days')), "\",\n  resortDepartureDate: \"").concat(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* timestampToApiDate */ "n"])(favoriteProduct.departureDate), "\",\n  childrenCount: ").concat(favoriteProduct.kids.length, ",\n  adultsCount: ").concat(favoriteProduct.adultsNumber, ",\n  birthdates: ").concat(birthdates, ",\n  departureOptionId: \"").concat(favoriteProduct.departureCity, "\"\n  price: {\n      value: ").concat(favoriteProduct.priceOfStay.bestPrice.value, "\n      currency: \"").concat(favoriteProduct.priceOfStay.currency, "\"\n  },\n  ");
};

var addBookmarkMutation = function addBookmarkMutation(favoriteProduct, appContext) {
  var gqlQuery = "mutation RootMutationType {\n    addBookmark(".concat(favoriteQueryParams(favoriteProduct), ") {\n        ").concat(getBookmarksQuery(appContext), "\n      }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runNoCacheQuery(gqlQuery, appContext, {
    requestName: 'CUSTOMER_ACCOUNT_ADD_FAVORITE'
  });
};

var deleteBookmarkMutation = function deleteBookmarkMutation(id, appContext) {
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var gqlQuery = "mutation RootMutationType {\n    deleteBookmark(id: \"".concat(id, "\") {\n        errorCode\n        errorDescription(content:\"").concat(cmsContent, "\" release:\"").concat(cmsRelease, "\")\n        errorKey\n      }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runNoCacheQuery(gqlQuery, appContext, {
    requestName: 'CUSTOMER_ACCOUNT_DELETE_FAVORITE'
  });
};

var deleteCustomerProposalMutation = function deleteCustomerProposalMutation(proposalId, appContext) {
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var gqlQuery = "mutation RootMutationType {\n    deleteCustomerProposal(proposalId: \"".concat(proposalId, "\") {\n        errorCode\n        errorDescription(content:\"").concat(cmsContent, "\" release:\"").concat(cmsRelease, "\")\n        errorKey\n      }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runNoCacheQuery(gqlQuery, appContext, {
    requestName: 'CUSTOMER_ACCOUNT_DELETE_PROPOSAL'
  });
};



/***/ }),

/***/ "QMQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useSearchBookings_useSearchBookings; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/partition.js
var partition = __webpack_require__("Zl10");
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("TYRa");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingSearchUtils.js











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var BOOKING_STATUSES = dist["constants"].BOOKING_STATUSES,
    TRAVELPLAN_TYPES = dist["constants"].TRAVELPLAN_TYPES;

var bookingSearchUtils_mapStayBooking = function mapStayBooking(favorite, _ref) {
  var _favorite$priceOfStay, _favorite$priceOfStay2, _favorite$priceOfStay3, _favorite$priceOfStay4;

  var status = _ref.status;
  return {
    attendees: [],
    categories: {
      isOption: false,
      isOptionRenewed: false,
      isStandard: false,
      isTravelPlan: true,
      isTravelPlanPrebooking: favorite.type === TRAVELPLAN_TYPES.TRAVELPLAN_TYPE_PRE_BOOKING,
      isTravelPlanStandard: favorite.type !== TRAVELPLAN_TYPES.TRAVELPLAN_TYPE_PRE_BOOKING
    },
    creationDate: '',
    dates: {
      duration: favorite.duration,
      endDate: Object(apiDate["n" /* timestampToApiDate */])(favorite.arrivalDate) || '',
      startDate: Object(apiDate["n" /* timestampToApiDate */])(favorite.departureDate) || ''
    },
    id: favorite.id || favorite.reference || '',
    isMultiSaleContracts: false,
    isMultiStays: false,
    isShoppingSearch: status === BOOKING_STATUSES.BOOKING_STATUS_BOOKMARK,
    membership: null,
    optionDurability: null,
    packages: [],
    payment: {
      due: {
        deadlineDate: '',
        formattedValue: ((_favorite$priceOfStay = favorite.priceOfStay) === null || _favorite$priceOfStay === void 0 ? void 0 : (_favorite$priceOfStay2 = _favorite$priceOfStay.bestPrice) === null || _favorite$priceOfStay2 === void 0 ? void 0 : _favorite$priceOfStay2.formattedValue) || '',
        value: ((_favorite$priceOfStay3 = favorite.priceOfStay) === null || _favorite$priceOfStay3 === void 0 ? void 0 : (_favorite$priceOfStay4 = _favorite$priceOfStay3.bestPrice) === null || _favorite$priceOfStay4 === void 0 ? void 0 : _favorite$priceOfStay4.value) || 0
      },
      isEnabled: false,
      paid: null,
      status: {
        isInCredit: false,
        isPaid: false,
        isPending: false,
        isUnPaid: true,
        name: ''
      }
    },
    status: {
      name: status,
      isArchived: false,
      isCanceled: false,
      isExpiredHope: false,
      isExpiredOption: false,
      isExpiredQuotation: false,
      isHope: false,
      isOption: false,
      isQuotation: false,
      isRequest: false,
      isSearch: true,
      isValidated: false
    },
    totalPrice: {
      formattedValue: '',
      value: 0
    },
    vendor: {
      isSoldByClubmed: true,
      isSoldByPartners: false,
      name: '',
      phoneNumber: '',
      soldBy: '',
      type: ''
    }
  };
};

var bookingSearchUtils_mapBooking = function mapBooking(favorite, _ref2) {
  var _favorite$upsells;

  var status = _ref2.status;
  return _objectSpread(_objectSpread({}, bookingSearchUtils_mapStayBooking(favorite, {
    status: status
  })), {}, {
    stays: [{
      accommodation: {
        rooms: [],
        stock: 0,
        streetViews: []
      },
      additionalServices: {
        activities: [],
        childcares: [],
        insurance: [],
        rentals: [],
        transfers: []
      },
      booking: _objectSpread({}, bookingSearchUtils_mapStayBooking(favorite, {
        status: status
      })),
      dates: {
        duration: favorite.duration,
        endDate: Object(apiDate["n" /* timestampToApiDate */])(favorite.arrivalDate) || '',
        isCurrent: false,
        isPast: false,
        isToCome: true,
        startDate: Object(apiDate["n" /* timestampToApiDate */])(favorite.departureDate) || ''
      },
      features: {
        easyArrival: {
          status: {
            isActivated: false,
            isAvailable: false,
            isDone: false,
            isNotYet: false,
            isUnavailable: false,
            isUneditable: false,
            isValidated: false,
            name: ''
          },
          url: ''
        },
        easyCheckInOut: {
          easyCheckIn: {
            isActivated: false,
            status: {
              isActivated: false,
              isAvailable: false,
              isDone: false,
              isNotYet: false,
              isUnavailable: false,
              isUneditable: false,
              isValidated: false,
              name: ''
            }
          },
          easyCheckOut: {
            isActivated: false,
            status: {
              isActivated: false,
              isAvailable: false,
              isDone: false,
              isNotYet: false,
              isUnavailable: false,
              isUneditable: false,
              isValidated: false,
              name: ''
            }
          }
        },
        easyTransfer: {
          serviceStatus: {
            isUpsellAvailable: false,
            isValidated: false,
            name: ''
          },
          status: {
            isActivated: false,
            isAvailable: false,
            isDone: false,
            isNotYet: false,
            isUnavailable: false,
            isUneditable: false,
            isValidated: false,
            name: ''
          }
        },
        policyForm: {
          status: {
            isAvailable: false
          }
        },
        feedback: {
          status: {
            isAvailable: false,
            name: ''
          },
          url: ''
        },
        pickYourRoom: {
          status: {
            isActivated: false,
            isResortOnly: false,
            isValidated: false,
            name: ''
          }
        }
      },
      id: '',
      isBookable: favorite.isBookable,
      participants: {
        adultsCount: favorite.adultsNumber,
        attendees: Object(toConsumableArray["a" /* default */])(favorite.kids),
        children: favorite.kids,
        childrenCount: favorite.childrenCount || (favorite.kids || []).length,
        totalCount: favorite.adultsNumber + (favorite.childrenCount || (favorite.kids || []).length || 0)
      },
      product: favorite.product,
      staff: [],
      stayIndex: 0,
      transfers: [],
      transport: favorite.departureCity && favorite.departureCity !== 'NO' ? {
        fromCity: upperFirst_default()(favorite.departureCity.toLowerCase()),
        fromCityCode: favorite.departureCity,
        inbounds: [],
        outbounds: [],
        toCity: '',
        toCityCode: '',
        type: '',
        types: []
      } : null,
      upsells: {
        activities: [],
        childcares: [],
        insurance: [],
        packages: [],
        rentals: [],
        transfers: ((_favorite$upsells = favorite.upsells) === null || _favorite$upsells === void 0 ? void 0 : _favorite$upsells.transfers) || [],
        whiteLabelServices: []
      },
      vouchers: []
    }]
  });
};

var bookmarkToBooking = function bookmarkToBooking(favorite) {
  return bookingSearchUtils_mapBooking(favorite, {
    status: BOOKING_STATUSES.BOOKING_STATUS_BOOKMARK
  });
};
var searchToBooking = function searchToBooking(favorite) {
  return bookingSearchUtils_mapBooking(favorite, {
    status: BOOKING_STATUSES.BOOKING_STATUS_SEARCH
  });
};
// EXTERNAL MODULE: ./src/client/context/FavoriteProductListContext.js
var FavoriteProductListContext = __webpack_require__("XGb2");

// CONCATENATED MODULE: ./src/client/components/utils/booking/useSearchBookings.js










var useSearchBookings_TRAVELPLAN_TYPES = dist["constants"].TRAVELPLAN_TYPES;
var useSearchBookings_useSearchBookings = function useSearchBookings() {
  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      favoriteProductList = _useContext.favoriteProductsState.favoriteProductList,
      loading = _useContext.loading;

  var _partition2 = partition_default()(favoriteProductList.filter(function (favorite) {
    return !!favorite.reference;
  }), function (favorite) {
    return favorite.type === useSearchBookings_TRAVELPLAN_TYPES.TRAVELPLAN_TYPE_STANDARD;
  }),
      _partition3 = Object(slicedToArray["a" /* default */])(_partition2, 2),
      travelPlans = _partition3[0],
      prebookings = _partition3[1];

  var favorites = [].concat(Object(toConsumableArray["a" /* default */])(travelPlans.map(searchToBooking)), Object(toConsumableArray["a" /* default */])(favoriteProductList.filter(function (favorite) {
    return !favorite.reference;
  }).map(bookmarkToBooking)));
  return {
    prebookings: prebookings.map(searchToBooking),
    favorites: favorites,
    isLoading: loading
  };
};

/***/ }),

/***/ "tUpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserSearchesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProposalPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProposalTotalPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProposalAccommodationsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSearchStreetViews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProposalTransportsQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__);




var getUserSearchesQuery = function getUserSearchesQuery(locale) {
  return " query {\n  userSearches {\n    adults\n    arrivalCity\n    children\n    birthdates\n    departureCity\n    departureDate\n    isBookable\n    reference\n    resort  {\n      badgeIcon\n      comfort\n      destination {\n        country\n      }\n      href\n      id\n      images\n      hasECSpace\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      isSummer\n      isTour\n      name\n    }\n    returnDate\n    transportType\n    price {\n      formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(locale), ")\n      value\n    }\n    type\n    upsells(types: [TRANSFER]) {\n      transfers {\n        pricingInfo {\n          id\n          isFullyPaid\n          isFullyRented\n          isIncluded\n          isPartiallyPaid\n          isPartiallyRented\n        }\n      }\n    }\n  }\n}");
};
var getProposalPriceQuery = function getProposalPriceQuery(appContext, proposalId) {
  return " query {\n  proposal(id: \"".concat(proposalId, "\") {\n    price {\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n    }\n    households(withSchedule: true) {\n      paymentSchedule {\n        total {\n          formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(appContext.locale), ")\n          value\n        }\n      }\n    }\n  }\n}");
};
var getProposalTotalPriceQuery = function getProposalTotalPriceQuery(appContext, proposalId) {
  return "query {\n  proposal(id: \"".concat(proposalId, "\") {\n    price {\n      total {\n        formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(appContext.locale), ")\n        value\n      }\n      totalWithoutDiscount {\n        formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(appContext.locale), ")\n        value\n      }\n    }\n  }\n}");
};
var getProposalAccommodationsQuery = function getProposalAccommodationsQuery(proposalId) {
  return "query {\n  proposal(id: \"".concat(proposalId, "\") {\n    accommodations {\n      bathroomEquipments {\n        id\n        label\n      }\n      category\n      categoryId\n      comfortId\n      comfortType\n      description\n      endDate\n      equipments {\n        id\n        label\n      }\n      exclusiveCollection\n      guest\n      id\n      label\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      quantity\n      ranking\n      rooms {\n        number\n      }\n      roomType\n      services {\n        id\n        label\n      }\n      startDate\n      strengths {\n        id\n        label\n      }\n      surface\n      view {\n        id\n        label\n      }\n      floorPlans\n    }\n  }\n}");
};
var getSearchStreetViews = function getSearchStreetViews(productId, accommodationCategoryIds) {
  return "query {\n  streetViews(productId: \"".concat(productId, "\", accommodationCategoryIds:[").concat(accommodationCategoryIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(','), "]) {\n    streetView {\n      latitude\n      longitude\n      heading\n      pitch\n      fov\n      url\n    }\n  }\n}");
};
var getProposalTransportsQuery = function getProposalTransportsQuery(proposalId) {
  return "query {\n  proposal(id: \"".concat(proposalId, "\") {\n    transports {\n      multiTransport\n      outbound {\n        transferIncluded\n        stayId\n        durationInMin\n        travelers {\n          id\n          name\n          firstName\n        }\n        cancellationPolicyType\n        travelSections {\n          transport {\n            baggage {\n              quantity\n              weight\n              unit\n            }\n            class\n            companyExploiter {\n              id\n              label\n              logo\n            }\n            companyOperator {\n              id\n              label\n              logo\n              url\n            }\n            travelNumber\n            type\n            vehicleType\n          }\n          departure {\n            airportLabel\n            cityId\n            date\n            id\n            label\n            terminalCode\n            time\n          }\n          arrival {\n            airportLabel\n            cityId\n            date\n            id\n            label\n            terminalCode\n            time\n          }\n        }\n      }\n      inbound {\n        transferIncluded\n        stayId\n        durationInMin\n        travelers {\n          id\n          name\n          firstName\n        }\n        cancellationPolicyType\n        travelSections{\n          transport {\n            baggage {\n              quantity\n              weight\n              unit\n            }\n            class\n            companyExploiter {\n              id\n              label\n              logo\n            }\n            companyOperator {\n              id\n              label\n              logo\n              url\n            }\n            travelNumber\n            type\n            vehicleType\n          }\n          departure{\n            airportLabel\n            cityId\n            date\n            id\n            label\n            terminalCode\n            time\n          }\n          arrival {\n            airportLabel\n            cityId\n            date\n            id\n            label\n            terminalCode\n            time\n          }\n        }\n      }\n    }\n  }\n}");
};

/***/ })

}]);